import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'app-chevron-selector',
    styleUrls: ['./chevron-selector.component.scss'],
    templateUrl: './chevron-selector.component.html',
})
export class ChevronSelectorComponent {
    private _disableLeft = false
    @Input()
    set disableLeft(disable: boolean) {
        this._disableLeft = disable
    }

    get disableLeft() {
        return this._disableLeft
    }

    private _disableRight = false
    @Input()
    set disableRight(disable: boolean) {
        this._disableRight = disable
    }

    get disableRight() {
        return this._disableRight
    }

    @Input({ required: false }) tooltipLeft = ''

    @Input({ required: false }) tooltipRight = ''

    @Output()
    public readonly leftClick: EventEmitter<void> = new EventEmitter()

    @Output()
    public readonly rightClick: EventEmitter<void> = new EventEmitter()

    nextValue() {
        this.rightClick.emit()
    }

    previousValue() {
        this.leftClick.emit()
    }
}
